import { render, staticRenderFns } from "./data-upload.vue?vue&type=template&id=1a2d181d&scoped=true&"
import script from "./data-upload.vue?vue&type=script&lang=ts&"
export * from "./data-upload.vue?vue&type=script&lang=ts&"
import style0 from "./data-upload.vue?vue&type=style&index=0&id=1a2d181d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d181d",
  null
  
)

export default component.exports